import React,{ useEffect,useState,useRef } from 'react'
// import Files from "./Files";
import { TrashIcon } from "@heroicons/react/solid";

const Etape1SP = ({renderError, formData, handleChange,isReadOnly,page,setFormData,setCommentaire,commentaire,isReadOnlyRh,routesConfig,formulaire,membrePersonnel }) => {
      const [excelData, setExcelData] = useState([]);
      const [excelDataEcole, setExcelDataEcole] = useState([]);
      const [posteIndex, setPosteIndex] = useState("");

      
      useEffect(() => {
  if (
    formData?.fonction &&
    Array.isArray(membrePersonnel) &&
    membrePersonnel.length > 0
  ) {
    const index = membrePersonnel.findIndex(
      (p) => p.fonction === formData.fonction
    );

    if (index !== -1) {
      // ✅ le poste existe toujours
      setPosteIndex(String(index));
    } else {
      // ⚠️ le poste n’existe PLUS
      setPosteIndex("");
    }
  }
}, [formData?.fonction, membrePersonnel]);

      // 🔹 calcul global : au moins un poste = Choix Libre
const hasCL = formData.postesVacants?.some(
  (poste) => poste.poste === "Choix Libre"
);

  useEffect(() => {
    const fetchExcelData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/listePostesVacants?nom=${formulaire}`);
        if (!response.ok) throw new Error("Erreur lors du fetch des données Excel");
        const result = await response.json();
        setExcelData(result.data || []);
      } catch (err) {
        console.error(err);
        renderError?.("Impossible de récupérer les données.");
      } 
    };
    fetchExcelData();
  }, []);

  useEffect(() => {
    const fetchExcelData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/listeDesEcoles`);
        if (!response.ok) throw new Error("Erreur lors du fetch des données Excel");
        const result = await response.json();
        // console.log(result)
        setExcelDataEcole(result.data || []);
      } catch (err) {
        console.error(err);
        renderError?.("Impossible de récupérer les données.");
      } 
    };
    fetchExcelData();
  }, []);


  function formatDate(dateInput) {
    try {
      if (!dateInput) return "Date invalide";
      // Si c'est déjà un objet Date valide
      if (dateInput instanceof Date && !isNaN(dateInput)) {
        return dateInput.toLocaleString("fr-CA", {
          dateStyle: "short",
          timeStyle: "short",
        });
      }
      // Sinon, on tente avec le constructeur Date
      const parsed = new Date(dateInput);
      // Si le constructeur ne fonctionne pas, on essaie avec Date.parse()
      if (isNaN(parsed)) {
        const timestamp = Date.parse(dateInput);
        if (!isNaN(timestamp)) {
          return new Date(timestamp).toLocaleString("fr-CA", {
            dateStyle: "short",
            timeStyle: "short",
          });
        } else {
          return "Date invalide";
        }
      }
      return parsed.toLocaleString("fr-CA", {
        dateStyle: "short",
        timeStyle: "short",
      });
    } catch (e) {
      return "Date invalide";
    }
  }
  // Handler pour modifier une cellule du tableau
// const handlePosteChange = (index, selectedPosteNumero) => {
//   // trouver la ligne correspondante dans excelData
//   const selectedData = excelData.find(row => row['Numéro de poste'] === Number(selectedPosteNumero));
//   // mettre à jour le formData
//   const updatedPostes = [...formData.postesVacants];
//   updatedPostes[index] = {
//     ...updatedPostes[index],
//     poste:selectedPosteNumero,
//     etp: selectedData ? selectedData['ETP'] : '',
//     ecole: selectedData ? selectedData['Lieu'] : '',
//     description: selectedData ? selectedData['Poste'] : '',
     
//   };
//   setFormData({ ...formData, postesVacants: updatedPostes });
// };

const handlePosteChange = (index, selectedPosteNumero) => {
  let selectedData = null;
  // 🔹 AEFO
  if (formulaire === "Aefo") {
    selectedData = excelData.find(
      row => row["Numéro de poste"] === Number(selectedPosteNumero)
    );
  }
  // 🔹 SCFP
  if (formulaire === "Scfp") {
    selectedData = excelData.find(
      row => String(row["Zone et poste"]) === String(selectedPosteNumero)
    );
  }
  // 🔹 FEESO
  if (formulaire === "Feeso") {
    // selectedData = excelData.find(
    //   row => String(row["# Poste"]) === String(selectedPosteNumero)
    // );

    const [posteNum, codeFunc] = String(selectedPosteNumero).split("|");

    selectedData = excelData.find((row) => {
      return (
        String(row["# Poste"]).trim() === String(posteNum).trim() &&
        String(row["code fonction"]).trim() === String(codeFunc).trim()
      );
    });
  }
  const updatedPostes = [...formData.postesVacants];
  // 🧠 base commune
  const basePoste = {
    ...updatedPostes[index],
    poste: selectedPosteNumero,
    palier:"",
    etp: "",
    ecole: "",
    description: "",
    titrePoste: "",
    nombre: "",
  };
  // 🔹 remplissage selon le formulaire
  if (formulaire === "Aefo") {
    basePoste.etp = selectedData ? selectedData["ETP"] : "";
    basePoste.ecole = selectedData ? selectedData["Lieu"] : "";
    basePoste.description = selectedData ? selectedData["Poste"] : "";
    basePoste.palier = selectedData ? selectedData["Palier"] : "";
  }
  if (formulaire === "Scfp") {
    basePoste.etp = selectedData
      ? selectedData["Pourcentage d'affectation"]
      : "";
    basePoste.ecole = selectedData
      ? selectedData["Lieu de \ntravail"]
      : "";
    basePoste.titrePoste = selectedData
      ? selectedData["Titre de poste"]
      : "";
  }
  if (formulaire === "Feeso") {
    basePoste.etp = selectedData
      ? selectedData["ETP (n,n)"]
      : "";
    basePoste.ecole = selectedData
      ? selectedData["École"]
      : "";  
    basePoste.nombre = selectedData
      ? selectedData["Nombre (n,n)"]
      : "";
    basePoste.titrePoste = selectedData
      ? selectedData["Titre du poste"]
      : "";
  }
  updatedPostes[index] = basePoste;
  setFormData({ ...formData, postesVacants: updatedPostes });
};
const POSTE_KEY_BY_FORMULAIRE = {
  Aefo: "Numéro de poste",
  Scfp: "Zone et poste",
  Feeso: "# Poste",
};
const getPosteValue = (row) =>
  row[POSTE_KEY_BY_FORMULAIRE[formulaire]] ?? "";
// Handler pour ajouter une nouvelle ligne dans le tableau
const handleAddPoste = () => {
  if (formData.postesVacants.length < 5) {
    setFormData({
      ...formData,
      postesVacants: [
        ...formData.postesVacants,
        {
          choix: formData.postesVacants.length + 1, // choix automatique
          poste: "",
          palier:"",
        // champs communs
        etp: "",
        
        ecole: "",
        // AEFO
        description: "",
        // SCFP / FEESO
        titrePoste: "",
        // FEESO
        nombre: "",
        },
      ],
    });
  }
};

const handleDeletePoste = (index) => {
  const updatedPostes = formData.postesVacants
    .filter((_, i) => i !== index)
    .map((poste, i) => ({ ...poste, choix: i + 1 })); // recalcul automatique du choix
  setFormData({ ...formData, postesVacants: updatedPostes });
};
  
const getAllowedTitresFeeso = (codeFonction = "") => {
  if (codeFonction.startsWith("5802")) {
    return ["5802"];
  }

  if (codeFonction.startsWith("5829")) {
    return ["5829"];
  }

  if (codeFonction.startsWith("5841")) {
    return ["5841"];
  }

  if (codeFonction.startsWith("3834")) {
    return ["3834"];
  }

  if (
    codeFonction.startsWith("3898")
  ) {
    return ["3898"];
  }

  if (
    codeFonction.startsWith("5861") || codeFonction.startsWith("5807")
  ) {
    return ["5861", "5807"];
  }

  // par défaut : tout afficher
  return [];
};

  const RadioQuestion = ({ name, label, value, onChange, width = "full", messageErreur }) => {
    return (
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-4 w-${width}`}>
            <label className="text-sm font-medium text-gray-800 flex items-center">
                {label}
                <span className="text-red-500 ml-1">*</span>
            </label>

            <div className="flex items-center gap-3">
                {["oui", "non"].map((option) => {
                    const isSelected = value === option;

                    return (
                        <label
                            key={option}
                            className={`
                                flex items-center justify-center min-w-[80px]
                                px-4 py-2 rounded-xl cursor-pointer
                                text-sm font-medium
                                border transition-all duration-200
                                focus-within:ring-2 focus-within:ring-blue-500
                                ${
                                    isSelected
                                        ? "bg-blue-600 text-white border-blue-600 shadow"
                                        : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                                }
                            `}
                        >
                            <input
                                type="radio"
                                name={name}
                                value={option}
                                checked={isSelected}
                                onChange={onChange}
                                className="sr-only"
                                disabled={isReadOnly && name !== "carteEnRegle"}
                            />
                            {option.charAt(0).toUpperCase() + option.slice(1)}
                        </label>
                    );
                })}
            </div>

            {messageErreur && (
                <div className="md:col-span-2 text-sm text-red-600">
                    {renderError(messageErreur)}
                </div>
            )}
        </div>
    );
};
  // HandleChange générique
  const handleChangeCheckBox = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "oui" : "non") : value,
    }));
  };
  const parseEmails = (text) => {
  if (!text) return "";
  // Regex pour détecter les emails
  const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
  // Séparer le texte en morceaux : emails et autres
  const parts = text.split(emailRegex);
  const matches = text.match(emailRegex) || [];
  const result = [];
  parts.forEach((part, i) => {
    result.push(part);
    if (matches[i]) {
      result.push(
        <a
          key={i}
          href={`mailto:${matches[i]}`}
          className="text-blue-600 hover:underline"
        >
          {matches[i]}
        </a>
      );
    }
  });
  return result;
};
const handleInputChange = (index, field, value) => {
  const updated = [...formData.postesVacants];
  updated[index][field] = value;
  setFormData({ ...formData, postesVacants: updated });
};
  /************************************************************************/
  return (
    <div className=" p-4 ">
    
        {/* <h1 className="text-2xl font-bold mb-6 text-black">
          Information générale
        </h1> */}
        <div  className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="numeroFormulaire"
              className="block text-sm font-medium text-blue-900"
            >
              Numéro de formulaire:
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              name="numeroFormulaire"
              value={formData.numeroFormulaire}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
          </div>
        </div>
        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
          </div>
          <div className="w-1/2  sm:ml-auto">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date :
            </label>
            <input
              type="date"
              id="dateSoumission"
              name="dateSoumission"
              value={formData.dateSoumission?.split("T")[0] ?? ""}
              onChange={handleChange}
              required
              disabled
              className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>
        
        <div className="w-full flex justify-center mt-6 mb-20">
  <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
    <p className="text-md font-bold flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
        />
      </svg>
      Formulaire de demande d'affectation { formulaire==="Aefo" &&("AEFO")}
    { formulaire==="Feeso" &&("FEESO")}
    { formulaire==="Scfp" &&("SCFP")}
    </p>
  </div>
</div>
        <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
     <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-blue-400 mr-2"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 2.01 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    </svg>
    { formulaire==="Aefo" &&("Personnel enseignant régulier AEFO")}
    { formulaire==="Feeso" &&("Personnel Aide-enseignante/enseignant FEESO")}
    { formulaire==="Scfp" &&("Personnel régulier Concierge en chef - SCFP")}
    
  </p>
</div>
{routesConfig
        .filter(routeConfig => routeConfig.label === `Form ${formulaire.toUpperCase()}`)
        .map(routeConfig => (
          <div
            key={routeConfig.path}
            className="flex items-start gap-3 bg-white border-l-4 border-blue-400 p-4 rounded-lg mt-10"
          >
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {parseEmails(routeConfig.description)}
            </p>
          </div>
        ))}

<div className="mt-[3%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-blue-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    Renseignements personnels
  </p>
</div>
        { formulaire==="Aefo" &&(
            <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="numeroODE"
              className="block text-sm font-medium text-blue-900"
            >
              Veuillez indiquer votre numéro de carte de l'Ordre des enseignants de l'ontario <span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="numeroODE"
              name="numeroODE"
              value={formData.numeroODE}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("numeroODE")}
          </div>
            
                <div className="w-3/5">
            <label
              htmlFor="numeroTelephone"
              className="block text-sm font-medium text-blue-900"
            >
            Veuillez indiquer le numéro auquel on peut vous joindre en cas de besoin <span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="text"
              id="numeroTelephone"
              name="numeroTelephone"
            //   value={formData.telephone}
              value={
                (() => {
                  const d = formData.numeroTelephone;
                  if (!d) return "";
                  let formatted = " ";
                  if (d.length <= 3) {
                    formatted += d;
                  } else if (d.length <= 6) {
                    formatted += d.slice(0, 3) + " " + d.slice(3);
                  } else {
                    formatted += d.slice(0, 3) + " " + d.slice(3, 6) + " " + d.slice(6);
                  }
                  
                  return formatted;
                })()
              }
              onChange={handleChange}
              readOnly={isReadOnly}
              maxLength={13} // Maximum of 10 digits
              placeholder="123 456 7890"
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("numeroTelephone")}
          </div>
            
        </div>)}
        <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="nom"
              className="block text-sm font-medium text-blue-900"
            >
              Nom, prenom légale <span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("nom")}
          </div>
          
          <div className="w-3/5">
            <label
              htmlFor="courriel"
              className="block text-sm font-medium text-blue-900"
            >
              Courriel <span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="courriel"
              name="courriel"
              value={formData.courriel}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("courriel")}
          </div>
        </div>
  { (formulaire === "Feeso" || formulaire === "Scfp")&&(         
  <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
    
     {Array.isArray(membrePersonnel) && membrePersonnel.length > 1 && page !== "Mes taches" && (formData.etatDemande==="Brouillon" ||formData.etatDemande===""||formData.etatDemande==="Rejeté") &&(
  <div className="w-3/5">
            <label className="block text-sm font-medium text-blue-900">
              Poste : <span className="text-red-900">*</span>
            </label>

            <select
              value={posteIndex}
              onChange={(e) => {
                const index = e.target.value;
                setPosteIndex(index);
                // ❌ si vide → reset et STOP
                  if (index === "") {
                    setFormData(prev => ({
                      ...prev,
                      rang: "",
                      lieuTravail: "",
                      fonction: "",
                       ...(formulaire === "Scfp" && {
                        lieuAnciennete: "",
                        fonctionValidation: "",
                      }),
                      ...(formulaire === "Feeso" && {
                        codeFonction: "",
                        oede: "",
                        etat: "",
                      }),
                      postesVacants: [],
                      
                    }));
                    return;
                  }
                const poste = membrePersonnel[index];

                setFormData(prev => ({
                  ...prev,
                  rang: poste.rang,
                  lieuTravail: poste.lieuTravail,
                  fonction: poste.fonction,

                  ...(formulaire === "Scfp" && {
                    lieuAnciennete: poste.lieuTravail,
                    fonctionValidation: poste.fonction,
                  }),

                  ...(formulaire === "Feeso" && {
                    codeFonction: poste.codeFonction?.trim() || "",
                    oede: poste?.oede || "",
                    etat: poste?.etat || "",
                  }),

                  postesVacants: [],
                }));
              }}
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl shadow-sm
                        focus:outline-none focus:ring-2 focus:ring-purple-400"
              required
            >
              <option value="">-- Choisir un poste --</option>
              {Array.isArray(membrePersonnel) &&
  membrePersonnel.map((p, i) => (
    <option key={i} value={i}>
      {p.fonction}
  {formulaire === "Feeso" && ` — code ${p.codeFonction}`}
    </option>
))}
            </select>
          </div>
)}

          <div className="w-3/5">
            <label
              htmlFor="rang"
              className="block text-sm font-medium text-blue-900"
            >
              Fonction <span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="rang"
              name="rang"
              value={formData.fonction}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("fonction")}
          </div> 
  </div>)}


        <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
          
          <div className="w-3/5">
            <label
              htmlFor="rang"
              className="block text-sm font-medium text-blue-900"
            >
              Rang d'ancienneté <span className="text-xl text-red-900" >*</span> :
            </label>
            <input
              type="text"
              id="rang"
              name="rang"
              value={formData.rang}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("rang")}
          </div> 
          <div className="w-3/5">
            <label
              htmlFor="lieuTravail"
              className="block text-sm font-medium text-blue-900"
            >
              Lieu de travail actuel <span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="text"
              id="lieuTravail"
              name="lieuTravail"
              value={formData.lieuTravail}
              required
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("lieuTravail")}
          </div>


        </div>

         { formulaire==="Aefo" &&(     
        <div className="mt-16 grid gap-0">
        <RadioQuestion
          name="qualifieSecondaire"
          label="Êtes-vous qualifié pour enseigner au secondaire ?"
          value={formData.qualifieSecondaire}
          onChange={handleChange}
          width={"[60%]"}
          messageErreur={"qualifieSecondaire"}
        />
        </div>)}
        { formulaire==="Aefo" &&(
        <div className="mt-10 grid gap-0">
        <RadioQuestion
          name="peutEnseignerAnglais"
          label="Seriez-vous en mesure d'enseigner un cours d'anglais ?"
          value={formData.peutEnseignerAnglais}
          onChange={handleChange}
          width={"[60%]"}
          messageErreur={"peutEnseignerAnglais"}
        />
        </div>)}
        
  <div className="mt-[6%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-purple-400 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      {/* Rectangle extérieur du tableau */}
      <rect x="3" y="4" width="18" height="16" rx="2" ry="2" />
      {/* Lignes verticales */}
      <line x1="9" y1="4" x2="9" y2="20" />
      <line x1="15" y1="4" x2="15" y2="20" />
      {/* Lignes horizontales */}
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="3" y1="16" x2="21" y2="16" />
    </svg>
    Affectations demandées
  </p>
</div>
{/* Tableau des postes vacants */}
<div className="w-[100%] mt-6">
<div className="w-full mt-8">
  <div className="flex items-start justify-between gap-4 mb-6">
    <div>
      <h3 className="text-xl font-semibold text-gray-800 tracking-tight">
        Tableau des postes vacants - ou tableau des écoles de mutation
      </h3>
      <p className="text-sm text-gray-600 mt-1">
        Maximum {formulaire === "Aefo"?5:3} choix affichés
      </p>
    </div>
  </div>

  <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-md">
    <table className="w-full  text-md">
      {/* HEADER */}
      <thead className="bg-blue-600 sticky top-0 z-10">
        <tr className="text-white">
          <th className="px-4 py-3 font-medium text-left w-12">Choix</th>
          <th className="px-4 py-3 font-medium text-left w-[15%]">Poste</th>
          <th className="px-4 py-3 font-medium text-left w-[18%]">ETP</th>
          <th className="px-4 py-3 font-medium text-left w-[25%]">École</th>

          {formulaire === "Aefo" && (
            <th className="px-4 py-3 font-medium text-left">
              Description du poste
            </th>
          )}

          {(formulaire === "Feeso" || formulaire === "Scfp") && (
            <th className="px-4 py-3 font-medium text-left">
              Titre du poste
            </th>
          )}

          {formulaire === "Feeso" && (
            <th className="px-4 py-3 font-medium text-left w-12">
              Nombre
            </th>
          )}

          <th className="px-4 py-3 font-medium text-center w-[2%]">Action</th>
        </tr>
      </thead>

      {/* BODY */}
      <tbody className="divide-y divide-gray-100">
        {Array.from({
          length: Math.min(5, formData.postesVacants?.length || 0),
        }).map((_, index) => {
          const posteActuel = formData.postesVacants[index]?.poste;
          const isCL = posteActuel === "Choix Libre";

          return (
            <tr
              key={index}
              className="hover:bg-blue-50/40 transition-colors"
            >
              {/* CHOIX */}
              <td className="px-4 py-4">
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">
                  {formData.postesVacants[index].choix}
                </span>
              </td>

              {/* POSTE */}
              <td className="px-4 py-3">
                <select
                  className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
                  focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400
                  transition text-gray-800 disabled:opacity-60"
                  value={posteActuel || ""}
                  onChange={(e) => handlePosteChange(index, e.target.value)}
                  disabled={isReadOnly}
                >
                  <option value="">Sélectionner</option>
                 {formulaire === "Aefo" &&(<option value="Choix Libre">Choix Libre</option>)} 

                  {excelData
                    .filter((row) => {
                      // 🔹 AEFO – filtre palier
                      if (
                        formData.qualifieSecondaire === "non" &&
                        formulaire === "Aefo"
                      ) {
                        return row["Palier"] === "Élémentaire";
                      }

                      // 🔹 FEESO – filtre selon poste occupé
                      if (formulaire === "Feeso") {
                        const normalizeCode = (v) => String(v ?? "").trim();
                        const codeFonction = normalizeCode(formData.codeFonction);
                        const titresAutorises = getAllowedTitresFeeso(codeFonction);

                        if (titresAutorises.length === 0) return true;
                        return titresAutorises.includes(
                          String(row["code fonction"]).trim()
                        );
                      }

                      // 🔹 SCFP – filtre selon fonction
                      if (formulaire === "Scfp") {
                        const fonction = (formData.fonction || "").toLowerCase();
                        const titrePoste = String(row["Titre de poste"] || "").toLowerCase();

                        if (fonction === "nettoyeur") {
                          return titrePoste.includes("nettoyeur");
                        }

                        if (fonction === "concierge") {
                          return (
                            titrePoste.includes("concierge") ||
                            titrePoste.includes("nettoyeur")
                          );
                        }

                        if (fonction === "concierge en chef") {
                          return true;
                        }
                      }

                      return true;
                    })
                    .map((row, i) => {
                      const posteValue = getPosteValue(row);

                      const value =
                        formulaire === "Feeso"
                          ? `${String(row["# Poste"]).trim()}|${String(
                              row["code fonction"]
                            ).trim()}`
                          : posteValue;

                      return (
                        <option key={`${value}-${i}`} value={value}>
                          {posteValue}
                          {formulaire === "Feeso" && ` — code ${row["code fonction"]}`}
                        </option>
                      );
                    })}
                </select>

                {renderError("Poste_")}
                {renderError(`Poste_${formData.postesVacants[index].choix}`)}
              </td>

              {/* ETP */}
              <td className="px-4 py-3">
                {isCL ? (
                  <select
                    className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
                    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400
                    transition text-gray-800 disabled:opacity-60"
                    value={formData.postesVacants[index]?.etp || ""}
                    onChange={(e) => handleInputChange(index, "etp", e.target.value)}
                    disabled={isReadOnly}
                  >
                    <option value="">Sélectionner</option>
                    <option value="Moins de 50%">Moins de 50%</option>
                    <option value="50% et plus">50% et plus</option>
                    <option value="Uniquement 100%">Uniquement 100%</option>
                  </select>
                ) : (
                  <input
                    type="text"
                    className="w-full bg-gray-100 border border-gray-200 rounded-xl px-3 py-2
                    text-gray-700"
                    value={formData.postesVacants[index]?.etp || ""}
                    onChange={(e) => handleInputChange(index, "etp", e.target.value)}
                    readOnly
                  />
                )}

                {renderError(`ETP_${formData.postesVacants[index].choix}`)}
              </td>

              {/* ÉCOLE */}
              <td className="px-4 py-3">
                {isCL ? (
                  <select
                    className="w-full bg-gray-50 border border-gray-200 rounded-xl px-3 py-2
                    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400
                    transition text-gray-800 disabled:opacity-60"
                    value={formData.postesVacants[index]?.ecole || ""}
                    onChange={(e) => handleInputChange(index, "ecole", e.target.value)}
                    disabled={isReadOnly}
                  >
                    <option value="">Sélectionner une école</option>

                    {excelDataEcole
                      .filter((row) => {
                        if (formData.qualifieSecondaire === "non") {
                          return row["Type d'école"] === "Élémentaire";
                        }
                        return true;
                      })
                      .map((row, i) => (
                        <option key={`${row.École}-${i}`} value={`${row.École}`}>
                          {`${row.École}`}
                        </option>
                      ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    className="w-full bg-gray-100 border border-gray-200 rounded-xl px-3 py-2
                    text-gray-700"
                    value={formData.postesVacants[index]?.ecole || ""}
                    onChange={(e) => handleInputChange(index, "ecole", e.target.value)}
                    readOnly
                  />
                )}

                {renderError(`Ecole_${formData.postesVacants[index].choix}`)}
              </td>

              {/* DESCRIPTION (AEFO) */}
              {formulaire === "Aefo" && (
                <td className="px-4 py-3">
                  <textarea
                      rows={2}
                      value={formData.postesVacants[index]?.description || ""}
                      onChange={(e) =>
                        handleInputChange(index, "description", e.target.value)
                      }
                      readOnly={!isCL}
                      disabled={isReadOnly}
                      className={`w-full border rounded-xl px-3 py-2
                      resize-none overflow-y-auto
                      focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400
                      transition ${
                        isCL ? "bg-gray-50 border-gray-200" : "bg-gray-100 border-gray-200"
                      }`}
                    />

                </td>
              )}

              {/* TITRE DU POSTE (SCFP + FEESO) */}
              {(formulaire === "Scfp" || formulaire === "Feeso") && (
                <td className="px-4 py-3">
                  <input
                    type="text"
                    title={formData.postesVacants[index]?.titrePoste || ""}
                    className={`w-full border rounded-xl px-3 py-2
                    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400
                    transition ${
                      isCL ? "bg-gray-50 border-gray-200" : "bg-gray-100 border-gray-200"
                    }`}
                    value={formData.postesVacants[index]?.titrePoste || ""}
                    onChange={(e) =>
                      handleInputChange(index, "titrePoste", e.target.value)
                    }
                    readOnly={!isCL}
                  />
                  {renderError(`titrePoste_${formData.postesVacants[index].choix}`)}
                </td>
              )}

              {/* NOMBRE (FEESO) */}
              {formulaire === "Feeso" && (
                <td className="px-4 py-3">
                  <input
                    type="text"
                    className={`w-full border rounded-xl px-3 py-2
                    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400
                    transition ${
                      isCL ? "bg-gray-50 border-gray-200" : "bg-gray-100 border-gray-200"
                    }`}
                    value={formData.postesVacants[index]?.nombre || ""}
                    onChange={(e) => handleInputChange(index, "nombre", e.target.value)}
                    readOnly={!isCL}
                  />
                </td>
              )}

              {/* ACTION */}
              <td className="px-4 py-3 text-center">
                {!isReadOnly && (
                  <button
                    type="button"
                    onClick={() => handleDeletePoste(index)}
                    className="inline-flex items-center justify-center p-2 rounded-xl
                    hover:bg-red-50 active:scale-95 transition group"
                    title="Supprimer"
                  >
                    <TrashIcon className="w-5 h-5 text-red-500 group-hover:text-red-600 transition" />
                  </button>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
</div>


 {((formData.postesVacants?.length < 5 && formulaire === "Aefo")
  || (formData.postesVacants?.length < 3 && formulaire !== "Aefo") )&& !isReadOnly && (
  <div className="mt-6 flex flex-col items-start gap-2">
    <button
      type="button"
      onClick={handleAddPoste}
      className="
        inline-flex items-center gap-2
        px-6 py-2.5
        bg-blue-600 hover:bg-blue-700
        text-white text-sm font-medium
        rounded-xl
        shadow-sm hover:shadow-md
        active:scale-[0.98]
        transition-all duration-200
      "
    >
      <span className="text-lg leading-none">+</span>
      Ajouter un choix
    </button>

    {renderError("PostesVacants")}
  </div>
)}
</div>
{(formulaire==="Feeso" || formulaire==="Scfp" || formulaire==="Aefo" ) &&(
<div className="mt-8 w-3/4 grid grid-cols-2  gap-0">
              <div className="w-full mt-4">
                <label
                  htmlFor="commentaires"
                  className="block text-sm font-medium text-blue-900"
                >
                  Veuillez indiquer des informations pertinentes et indispensables en lien avec votre placement :
                </label>
                 <p className="mt-1 text-sm text-gray-700 leading-relaxed">
                    80 caractères maximum
                </p>
                <textarea
                  placeholder="Ajoutez une qualification..."
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  rows="2"
                  id="commentaires"
                  name="commentaires"
                  value={formData.commentaires}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                  
      maxLength={80}
                />
                <div className="text-sm text-gray-500 text-right mt-1">
      {formData.commentaires.length}/80
    </div>
                {/* {renderError("commentaires")} */}
              </div>
            </div>)}

{(formulaire==="Feeso" || (formulaire==="Aefo" && hasCL )) &&(
<div className="mt-[6%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-yellow-500 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4m0 4h.01M12 2a10 10 0 110 20 10 10 0 010-20z"
      />
    </svg>
     
     {formulaire === "Aefo"
        ? "Important"
        : "Entente ou plan de formation en cours avec le conseil"}
  </p>
</div>)}
{formulaire==="Aefo" && hasCL &&(
      <div className="mt-16 grid gap-0">
        <RadioQuestion
          name="considererAutrePoste"
          label="Dans l'éventualité où je n'obtiendrais aucun des postes sollicités, je souhaiterais être pris(e) en considération pour tout autre poste susceptible de se libérer au sein des établissements correspondant à mes choix libres mentionnés ci-dessus, quelle que soit leur répartition en termes de pourcentage d'affectation."
          value={formData.considererAutrePoste}
          onChange={handleChange}
          width={"[80%]"}
          messageErreur={"considererAutrePoste"}
        />
        </div>)}
{formulaire === "Feeso" && (
        <div className="mt-16 grid gap-0">
        <RadioQuestion
          name="ententeFormation"
          label="avez vous une entente ou plan de formation en cours avec le conseil ?"
          value={formData.ententeFormation}
          onChange={handleChange}
          width={"[80%]"}
          messageErreur={"ententeFormation"}
        />
        </div>)}
{/* {formulaire==="Aefo" && hasCL &&(
        <div className="mt-8 w-3/4 grid grid-cols-2  gap-0">
              <div className="w-full mt-4">
                <label
                  htmlFor="commentaires"
                  className="block text-sm font-medium text-blue-900"
                >
                  Commentaires :
                </label>
                 <p className="mt-1 text-sm text-gray-700 leading-relaxed">
                    40 caractères maximum
                </p>
                <textarea
                  placeholder="Ajoutez une qualification..."
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  rows="2"
                  id="commentaires"
                  name="commentaires"
                  value={formData.commentaires}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                  
      maxLength={40}
                />
                <div className="text-sm text-gray-500 text-right mt-1">
      {formData.commentaires.length}/40
    </div>
              </div>
            </div>)} */}
        

        <div className="mt-[4%] w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
  <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-yellow-500 mr-2"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M16.862 3.487a2.25 2.25 0 013.182 3.182L7.125 19.587l-4.5 1.5 1.5-4.5L16.862 3.487z"
      />
    </svg>
    Signature
  </p>
</div>
{/* Checkbox */}
<div className="mt-5 p-5 bg-white rounded-2xl shadow-lg border border-gray-200">
  <label className="flex items-center cursor-pointer space-x-4 relative">
    {/* Hidden checkbox but still part of layout */}
    <input
      type="checkbox"
      name="SignatureElectronique"
      checked={formData.SignatureElectronique === "oui"}
      onChange={handleChangeCheckBox}
      className="absolute opacity-0 w-6 h-6"
      disabled={isReadOnly}
    />
    {/* Custom box */}
        <span className="flex items-center justify-center h-6 w-6 rounded-lg border-2 border-gray-300 bg-gray-50 transition-all duration-300 
      checked:border-blue-500 peer-checked:bg-blue-50">
      {/* Check icon */}
      {formData.SignatureElectronique === "oui" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-10 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={3}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      )}
    </span>
    {/* Label text */}
    <span className="text-gray-900 font-medium text-sm select-none">
      Je certifie que les informations fournies sont exactes, complètes et vérifiées.
    </span>
    {renderError("SignatureElectronique")}
  </label>
</div>
{page === "Mes taches" && (
  <>
    {/* ===== SECTION RH - COMMUNE ===== */}
    <div className="mt-[8%] w-full">
      <div className="w-full h-1 bg-gray-500 mb-10"></div>
      <div className="bg-gradient-to-r from-blue-900 to-blue-900 py-4 shadow-lg rounded-t-2xl">
        <p className="text-xl font-bold text-white ml-4 tracking-wide flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-blue-300 mr-3"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.67 0-8 1.34-8 4v2h8v-2c0-.69.28-1.32.74-1.77C9.43 14.48 10.68 14 12 14c1.32 0 2.57.48 3.26 1.23.46.45.74 1.08.74 1.77v2h8v-2c0-2.66-5.33-4-8-4H8z" />
          </svg>
          Section Ressources Humaines
        </p>
      </div>
    </div>
    {/* ===== CHAMPS RH (AEFO + SCFP seulement) ===== */}
    {(formulaire === "Aefo" || formulaire === "Scfp") && (
      <>
        {/* Ligne 1 */}
        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          {/* Matricule */}
          <div className="w-3/5">
            <label className="block text-sm font-medium text-blue-900">
              Matricule central <span className="text-xl text-red-900">*</span>:
            </label>
            <input
              type="text"
              name="matricule"
              value={formData.matricule}
              readOnly
              className="mt-1 w-full p-3 border rounded-xl"
            />
            {renderError("matricule")}
          </div>
          {/* Champ variable */}
          <div className="w-3/5">
            <label className="block text-sm font-medium text-blue-900">
              {formulaire === "Aefo" ? "Affectation" : "fonction"}
              <span className="text-xl text-red-900">*</span>:
            </label>
            <input
              type="text"
              name={formulaire === "Aefo" ? "affectation" : "fonctionValidation"}
              value={
                formulaire === "Aefo"
                  ? formData.affectation
                  : formData.fonctionValidation
              }
              onChange={handleChange}
              readOnly={formulaire === "Aefo"}
              className="mt-1 w-full p-3 border rounded-xl"
            />
            {renderError(formulaire === "Aefo" ? "affectation" : "fonctionValidation")}
          </div>
        </div>
        {/* Ligne 2 */}
        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-3/5">
            <label className="block text-sm font-medium text-blue-900">
              {formulaire === "Aefo"
                ? "Surnuméraire"
                : "Lieu d'ancienneté"}
              :
            </label>
            <input
              type="text"
              name={
                formulaire === "Aefo"
                  ? "surnumeraire"
                  : "lieuAnciennete"
              }
              value={
                formulaire === "Aefo"
                  ? formData.surnumeraire
                  : formData.lieuAnciennete
              }
              onChange={handleChange}
              readOnly={formulaire === "Aefo"}
              className="mt-1 w-full p-3 border rounded-xl"
            />
            {formulaire === "Scfp" && renderError("lieuAnciennete")}
          </div>
        </div>
      </>
    )}
    {formulaire === "Feeso" && (
      <>
        {/* Ligne 1 */}
        <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
          {/* Matricule */}
          <div className="w-3/5">
            <label className="block text-sm font-medium text-blue-900">
              No OEDE <span className="text-xl text-red-900">*</span>:
            </label>
            <input
              type="text"
              name="oede"
              value={formData.oede}
              readOnly
              className="mt-1 w-full p-3 border rounded-xl"
            />
          </div>
          <div className="w-3/5">
            <label className="block text-sm font-medium text-blue-900">
              État <span className="text-xl text-red-900">*</span>:
            </label>
            <input
              type="text"
              name="etat"
              value={formData.etat}
              readOnly
              className="mt-1 w-full p-3 border rounded-xl"
            />
          </div>
          
          
        </div>
      </>
    )}
    {/* ===== COMMENTAIRE RH (TOUS) ===== */}
    <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
         
          <div className="w-full mt-4">
                <label
                  htmlFor="commentaireRh"
                  className="block text-sm font-medium text-blue-900"
                >
                  Commentaire RH:
                </label>
                <textarea
                  placeholder="Ajoutez une qualification..."
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                  rows="5"
                  id="commentaire"
                  name="commentaire"
                  value={commentaire}
                  onChange={(e) => setCommentaire(e.target.value)}
                  // readOnly={isReadOnlyRh}
                />
                {renderError("commentaireRH")}
              </div>
        </div>
    {/* ===== TABLE COMMENTAIRES (TOUS) ===== */}
    <div className="mt-8 w-3/4">
      <h3 className="font-bold text-lg mb-4">
        Liste des commentaires :
      </h3>
      <div className="overflow-x-auto rounded-xl border">
        <table className="min-w-full bg-white divide-y">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="p-3 text-left">Nom</th>
              <th className="p-3 text-left">Courriel</th>
              <th className="p-3 text-left">État</th>
              <th className="p-3 text-left">Date</th>
              <th className="p-3 text-left">Commentaire</th>
            </tr>
          </thead>
          <tbody>
            {formData.traitant.map((note) => (
              <tr key={note.id} className="hover:bg-gray-50">
                <td className="p-3">{note.nom}</td>
                <td className="p-3">{note.email}</td>
                <td className="p-3">{note.etatDemande}</td>
                <td className="p-3">
                  {formatDate(note.dateHeure)}
                </td>
                <td className="p-3 py-2 max-w-xs break-words whitespace-pre-wrap overflow-y-auto">{note.commentaire}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>
)}


    </div>
  );
};
export default Etape1SP
